export const yesNoOptions = [
  {
    code: "Yes",
    key: "Yes",
    value: true,
    label: "Yes"
  },
  {
    code: "No",
    key: "No",
    value: false,
    label: "No"
  }
];
export const YesNoList = [
  {
    code: "Yes",
    key: "Yes",
    value: "yes",
    label: "Yes"
  },
  {
    code: "No",
    key: "No",
    value: "no",
    label: "No"
  }
];

export const YesNoNaList = [
  {
    code: "Yes",
    key: "Yes",
    value: "yes",
    label: "Yes"
  },
  {
    code: "No",
    key: "No",
    value: "no",
    label: "No"
  },
  {
    code: "Na",
    key: "Na",
    value: "NA",
    label: "NA"
  }
];
export const MEETINGCONDUCTEDLIST = [
  {
    code: "Business Premises of the Company ",
    key: "Business Premises of the Company ",
    value: "Business Premises of the Company ",
    label: "Business Premises of the Company "
  },
  {
    code: "RAK Bank Premises ",
    key: "RAK Bank Premises ",
    value: "RAK Bank Premises ",
    label: "RAK Bank Premises "
  },
  {
    code: "others",
    key: "others",
    value: "others",
    label: "Others"
  }
];
//ro-assist-brd3-15
export const ActivePassiveOptions = [
  {
    code: "Active",
    key: "Active",
    value: "active",
    label: "Active"
  },
  {
    code: "Passive",
    key: "Passive",
    value: "passive",
    label: "Passive"
  }
];

export const enumYesNoOptions = [
  {
    code: "Yes",
    key: "Yes",
    value: "yes",
    label: "Yes"
  },
  {
    code: "No",
    key: "No",
    value: "no",
    label: "No"
  }
];
export const YesNoOptions = [
  {
    code: "Yes",
    key: "Yes",
    value: "Yes",
    label: "Yes"
  },
  {
    code: "No",
    key: "No",
    value: "No",
    label: "No"
  }
];
//ro-assist-brd1-5
export const OthersOption = {
  code: "Others",
  displayText: "Others",
  key: "Others",
  value: "Others"
};
